(function () {
  class GWP {
    constructor() {
      // console.log('GWP START');

      this.blocks = this.prepBlocks();
      console.log("After Blocks:", this.blocks);
      this.cart = null;
      this.qualifiedCampaigns = [];
      this.gift_products = {};
      this.isLoading = false;

      this.addItem = this.addItem.bind(this);
      this.attachCartEvents = this.attachCartEvents.bind(this);
      this.cartHasGWP = this.cartHasGWP.bind(this);
      this.getCart = this.getCart.bind(this);
      this.qualifyByTotal = this.qualifyByTotal.bind(this);
      this.getQualifiedCampaigns = this.getQualifiedCampaigns.bind(this);
      this.gwpItemIsPersistent = this.gwpItemIsPersistent.bind(this);
      this.start = this.start.bind(this);

      this.attachCartEvents();

      // The universal inclusion of window.PDP will run this automatically
      if (!window.PDP) {
        this.start();
      }

      // console.log('GWP DATA', data);
    }

    prepBlocks() {
      const url = this.getJsonFromUrl();
      const hasCookie = localStorage.getItem("gwp-campaign");
      const data = JSON.parse(
        document.querySelector("script[data-gwp]").innerHTML
      );

      return [...Object.keys(data)].reduce((items, key) => {
        if (key === "order_by_id") {
          items[key] = data[key];
          return items;
        }

        items[key] = data[key].filter((block) => {
          if (block.parameters.key.length && block.parameters.value.length) {
            const isUrlSelectedGWP =
              url[block.parameters.key] == block.parameters.value;

            if (isUrlSelectedGWP)
              localStorage.setItem("gwp-campaign", block.id);
            return isUrlSelectedGWP || hasCookie === block.id;
          }

          return true;
        });

        return items;
      }, {});
    }

    getJsonFromUrl(url) {
      if (!url) url = location.search;
      var query = url.substr(1);
      var result = {};
      query.split("&").forEach(function (part) {
        var item = part.split("=");
        if (!item[0].length || !item[1]) return;
        result[item[0]] = decodeURIComponent(item[1]);
      });
      return result;
    }

    addItem(id, quantity = 1, properties = {}) {
      var items = [
        {
          id,
          quantity,
          properties: {
            _gift: "yes",
            ...properties,
          },
        },
      ];

      const adding = {
        items,
      };

      return fetch("/cart/add.js", {
        body: JSON.stringify(adding),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          /* we have JSON */
          console.log(json);
          return json;
        })
        .catch(function (err) {
          /* uh oh, we have error. */
          console.error(err);
        });
    }

    attachCartEvents() {
      $("body").on("ajaxCart.afterCartLoad", (event, cart) => {
        this.cart = { ...cart };
        this.start();
      });
    }

    cartHasGWP() {
      return Boolean(this.gwpInCart());
    }

    removeCartItems(keys) {
      const body = [...keys].reduce(
        (body, key) => {
          body.updates[key] = 0;

          return body;
        },
        { updates: {} }
      );

      return fetch("/cart/update.js", {
        body: JSON.stringify(body),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          /* we have JSON */
          console.log(json);

          return json;
        })
        .catch(function (err) {
          /* uh oh, we have error. */
          console.error(err);
        });
    }

    changeCartItem(key, quantity) {
      const item = {
        id: key,
        quantity,
      };

      return fetch("/cart/change.js", {
        body: JSON.stringify(item),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          /* we have JSON */
          console.log(json);

          return json;
        })
        .catch(function (err) {
          /* uh oh, we have error. */
          console.error(err);
        });
    }

    // Should return non-persistent items.
    gwpInCart(multi) {
      const giftInCart = [...this.cart.items]
        .filter((item) => {
          return Boolean(item.properties) && item.properties._gift === "yes";
        })
        .filter(this.gwpItemIsPersistent);

      return multi ? giftInCart : giftInCart[0];
    }

    gwpItemIsPersistent(item) {
      // Item should be an actual Shopify Cart Item.
      // Including persistent campaigns.
      const allQualifyingCampaigns = this.getQualifiedCampaigns(
        this.cart,
        true
      );
      const giftItems = [...allQualifyingCampaigns].map(({ gift }) => gift);

      return !giftItems.includes(item.handle);
    }

    getCart() {
      return fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          this.cart = cart;

          return cart;
        })
        .catch(() => null);
    }

    getProduct(handle) {
      return fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((res) => {
          console.warn("Product Response", res);
          this.gift_products[handle] = { ...res };
          return res;
        })
        .catch(() => null);
    }

    getQualifiedCampaigns(cart, persistent = false) {
      const { blocks } = this;
      delete blocks["order_by_id"];
      const campaignKeys = Object.keys(this.blocks);
      const urlParameters = this.getJsonFromUrl();

      const campaignsThatQualify = [...campaignKeys].reduce(
        (campaigns, key) => {
          let typeCampaigns = this.blocks[key];
          let qualifiedByType = [];

          if (key === "by_total") {
            const qualifyByTotal = this.qualifyByTotal(
              cart,
              typeCampaigns,
              persistent
            );
            qualifiedByType = qualifiedByType.concat(qualifyByTotal);
          }

          campaigns = campaigns.concat(qualifiedByType);

          return campaigns;
        },
        []
      );

      console.warn(
        "Campaigns That Qualify",
        { blocks: this.blocks, urlParameters, campaignKeys },
        campaignsThatQualify
      );

      return campaignsThatQualify;
    }

    getQualifiedPersistentCampaigns(cart) {}

    qualifyByTotal(cart, blocks, persistent) {
      if (!cart) return [];

      if (persistent) {
        // Remove persistent GWP blocks. Handle these separately.
        blocks = [...blocks].filter(({ persistent }) => persistent);

        // Push persistent type GWP items to the end.
        // blocks = [...blocks].sort((a,b) => {
        //     // push all persistent items to the end.
        //     let aVal = a.persistent ? 0 : 1;
        //     let bVal = b.persistent ? 0 : 1;

        //     return bVal - aVal;
        // })
      } else {
        // Remove persistent GWP blocks. Handle these separately.
        blocks = [...blocks].filter(({ persistent }) => !persistent);
      }

      const totalWithoutGWP = cart.items.reduce((total, item) => {
        if (Boolean(item.properties) && item.properties._gift === "yes")
          return total;

        total += item.final_line_price;

        return total;
      }, 0);

      const priceInDollars = Math.round(totalWithoutGWP / 100);

      const blockThatQualifies = [...blocks].filter((block) => {
        if (block.over_under === "under")
          return priceInDollars < block.threshold && 0 < priceInDollars;

        if (block.over_under === "over")
          return block.threshold <= priceInDollars;

        return false;
      });

      return blockThatQualifies;
    }

    async performGWPSwap() {
      const userGWP = this.gwpInCart();
      const removedGWP = await this.changeCartItem(userGWP.key, 0);

      this.addGwp();
    }

    async addGwp(campaigns) {
      const $self = this;
      const [campaign, ...rest] = campaigns || this.qualifiedCampaigns;
      const cart = this.cart;

      const cartGifts = [...cart.items]
        .filter((item) => {
          return Boolean(item.properties) && item.properties._gift === "yes";
        })
        .map((item) => item.handle);

      // Get campaigns, sort by threshold. Only keep highest threshold + persistents
      const campaignsNotInCart = [campaign, ...rest]
        .filter((campaign) => {
          console.log("Campaign Check", campaign);
          return !cartGifts.includes(campaign.gift);
        })
        .sort((a, b) => b.threshold - a.threshold)
        .reduce((final, campaign) => {
          if (final.length > 0 && !campaign.persistent) return final;

          final.push(campaign);
          return final;
        }, []);

      console.log("Add GWP!!", {
        campaign,
        rest,
        cart: this.cart,
        campaignsNotInCart,
      });

      async function prepItem(campaign) {
        const newGWP = await $self.getProduct(campaign.gift);
        const gwpVariant = [...newGWP.variants].find((variant) => {
          if (campaign.variant_id) {
            return variant.id == campaign.variant_id;
          }

          return variant.available;
        });

        const properties = {};

        if (campaign.pair) {
          properties["Earring"] = "Pair";
        }

        return {
          id: gwpVariant.id,
          quantity: campaign.pair ? 2 : 1,
          properties,
        };
      }

      const campaignsToAdd = await Promise.all(
        [...campaignsNotInCart].map(prepItem)
      );

      console.log("Add GWP Items:", campaignsToAdd);
      console.trace();

      for (let i = 0; i < campaignsToAdd.length; i++) {
        const campaign = campaignsToAdd[i];

        await this.addItem(campaign.id, campaign.quantity, campaign.properties);
      }

      this.cart = await this.getCart();
      //   window.AjaxCart.getCart(window.AjaxCart.buildCart);
      document.querySelector('[data-controller="cartform"]').dispatchEvent(
        new CustomEvent("cartform:reload", {
          detail: { open: false },
        })
      );

      return;
    }

    gwpIsCorrect() {
      const userGWP = this.gwpInCart();
      const [campaign, ...rest] = this.qualifiedCampaigns;

      console.log("Campaign does not exist", { campaign, userGWP });

      if (!campaign) return false;

      console.log("GWP IS Correct:", {
        handle: userGWP.handle,
        gift: campaign.gift,
        gwpQty: userGWP.quantity,
        campaignQty: campaign.quantity,
        campaign,
        userGWP,
      });

      return (
        userGWP.handle === campaign.gift &&
        userGWP.quantity === campaign.quantity
      );
    }

    persistentGWP() {
      // Including persistent campaigns.
      const allQualifyingCampaigns = this.getQualifiedCampaigns(
        this.cart,
        true
      );
      const gifts = [...allQualifyingCampaigns].map(({ gift }) => gift);
      const { cart } = this;

      const gwpsInCart = [...this.cart.items]
        .filter((item) => {
          return Boolean(item.properties) && item.properties._gift === "yes";
        })
        .map(({ handle }) => handle);

      const missingGifts = [...allQualifyingCampaigns].filter(
        ({ gift }) => !gwpsInCart.includes(gift)
      );

      if (missingGifts.length) {
        this.addGwp(missingGifts);
      }
      console.log(
        "There are persistent qualifying campaigns:",
        { missingGifts },
        allQualifyingCampaigns
      );
    }

    async start() {
      console.log("GWP START:", this.isLoading);
      if (this.isLoading) return;
      this.isLoading = true;
      this.cart = await this.getCart();
      this.qualifiedCampaigns = this.getQualifiedCampaigns(this.cart);

      // Should return GWP that are non-persistent.
      const userGWP = this.gwpInCart();

      console.log("Qualified Campaigns", this.qualifiedCampaigns);
      console.log("Start", this.cart);

      console.log(
        "Cart Has GWP?",
        { userGWP },
        this.cartHasGWP(),
        this.qualifiedCampaigns
      );
      this.persistentGWP();

      if (this.qualifiedCampaigns[0] && !this.cartHasGWP()) {
        console.log("GWP Stage 1");
        this.addGwp();

        //   window.AjaxCart.getCart(window.AjaxCart.buildCart);
        document.querySelector('[data-controller="cartform"]').dispatchEvent(
          new CustomEvent("cartform:reload", {
            detail: { open: false },
          })
        );
        this.cart = await this.getCart();

        this.isLoading = false;
        return;
      }

      if (
        this.cartHasGWP() &&
        !this.gwpIsCorrect() &&
        this.qualifiedCampaigns.length
      ) {
        console.log("GWP Stage 2", !this.gwpIsCorrect());
        let swap = await this.performGWPSwap();

        this.isLoading = false;
        return;
      }

      if (this.cartHasGWP()) {
        console.log("GWP Stage 3");
        const gwpItemInCart = this.gwpInCart();

        // console.warn('Cart has GWP', gwpItemInCart);

        if (this.qualifiedCampaigns.length === 0) {
          const gwpsItems = this.gwpInCart(true);
          console.log("MULTI REMOVE!!", gwpsItems);

          const cartUpdate = await this.removeCartItems(
            [...gwpsItems].map((item) => item.key)
          );

          //   window.AjaxCart.getCart(window.AjaxCart.buildCart);
          document.querySelector('[data-controller="cartform"]').dispatchEvent(
            new CustomEvent("cartform:reload", {
              detail: { open: false },
            })
          );
          this.cart = await this.getCart();

          this.isLoading = false;
          return;
        }

        // console.warn('Cart Change', cartChange);

        if (!this.gwpIsCorrect()) {
          let swap = await this.performGWPSwap();

          this.isLoading = false;
          return;
        }
      }
      this.isLoading = false;
    }
  }

  window.GWP = new GWP({});
})();
